module.exports = __webpack_public_path__ + "img/2-3.566123ca.jpg";